const focusItems = [
  {
    label: '重磅爆料',
    title: '体内精69xxxxx独家内幕追踪',
    desc: '深度挖掘不为人知的行业内幕，黑料社持续追踪一手信息源，还原事件真相。每期聚焦一个核心事件，多角度剖析。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20editorial%20composition%20with%20dramatic%20crimson%20highlight%20on%20dark%20void%20background%2C%20mysterious%20geometric%20focal%20point%2C%20cinematic%20atmosphere%20with%20warm%20tonal%20gradient%2C%20high%20contrast%20professional%20media%20aesthetic%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-01-hlv&orientation=landscape',
    tag: '独家',
  },
  {
    label: '社区热帖',
    title: '社区热议：本周最炸裂爆料合集',
    desc: '黑料社区用户自发整理的近期最热爆料合集，涵盖娱乐圈、商业圈与社会事件，热度持续飙升的话题一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20composition%20with%20warm%20amber%20lighting%20streaks%20across%20deep%20charcoal%20background%2C%20layered%20geometric%20forms%2C%20modern%20media%20portal%20vibe%2C%20bold%20contrast%20editorial%20style%2C%20no%20text%20or%20faces&width=800&height=500&seq=carousel-02-hlv&orientation=landscape',
    tag: '热门',
  },
  {
    label: '视频精选',
    title: '24小时最新上线黑料视频速览',
    desc: '实时更新最新上传的黑料视频，确保不遗漏任何关键爆料。每日精选高热度内容优先展示，快速掌握资讯动态。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20with%20glowing%20reddish%20circular%20accents%20and%20subtle%20grid%20patterns%2C%20video%20platform%20theme%20with%20dynamic%20motion%20blur%20effects%2C%20professional%20dark%20editorial%20atmosphere%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-03-hlv&orientation=landscape',
    tag: '新鲜',
  },
  {
    label: '深度专题',
    title: '黑料社年度重磅盘点回顾',
    desc: '回顾本年度最具影响力的爆料事件，从时间线梳理到后续影响，完整呈现每个事件的来龙去脉与社区讨论精华。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20dark%20composition%20with%20layered%20translucent%20crimson%20shapes%20and%20dramatic%20shadow%20depth%2C%20sophisticated%20media%20publication%20aesthetic%2C%20warm%20highlight%20against%20deep%20background%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-04-hlv&orientation=landscape',
    tag: '专题',
  },
  {
    label: '互动话题',
    title: '社区最活跃讨论版块实时热榜',
    desc: '黑料社区用户互动量最高的讨论区域，覆盖各类焦点话题。参与讨论、分享观点，与数十万用户共同追踪爆料动态。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20with%20amber%20and%20crimson%20intersecting%20light%20lines%20creating%20dynamic%20network%20feel%2C%20community%20platform%20atmosphere%2C%20modern%20dark%20editorial%20composition%2C%20no%20text%20or%20people&width=800&height=500&seq=carousel-05-hlv&orientation=landscape',
    tag: '互动',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            精选近期最受关注的黑料专题内容，一次浏览所有重磅爆料
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {focusItems.map((item, i) => (
            <article
              key={i}
              className={`group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all hover:border-primary-300/40 ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative ${i === 0 ? 'aspect-[16/9] lg:aspect-auto lg:h-full' : 'aspect-[16/10]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading={i > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-white text-xs font-bold uppercase tracking-wider">
                  {item.tag}
                </span>
              </div>
              <div className={`absolute bottom-0 left-0 right-0 p-4 md:p-5 ${i === 0 ? 'lg:p-6' : ''}`}>
                <span className="text-xs text-accent-400 font-medium tracking-wide">{item.label}</span>
                <h3 className={`font-heading font-bold text-white mt-1 ${i === 0 ? 'text-xl md:text-2xl' : 'text-base md:text-lg'}`}>
                  {item.title}
                </h3>
                {i === 0 && (
                  <p className="text-sm text-white/70 mt-2 line-clamp-2">{item.desc}</p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}